<template>
  <div v-if="visible" class="debug">
    <h3 class="debug__title">Debug</h3>
    <div class="debug__status">Status code: {{ statusCode }}</div>
    <div class="debug__message">{{ message }}</div>
  </div>
</template>

<script>
/**
 * Debug comonent for error page.
 * Provides developers with status code and error text.
 */
export default {
  data() {
    const { message, statusCode } = this.$parent.payload || this.$vnode.context.payload;
    const visible = process.env.NODE_ENV === 'development' || this.$auth.isAdmin;

    return { message, statusCode, visible };
  },
};
</script>

<style lang="scss" scoped>
.debug {
  padding: 10px;
  outline: 1px dashed grey;

  &__title {
    padding-bottom: 10px;
  }

  &__status {
    color: map-get($map: $colors, $key: error);
    font-weight: bold;
  }
}
</style>
